import React from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-5">
          {/* Left Column - Text Content */}
          <div className="col-lg-7">
            <div className="section-title position-relative pb-3 mb-5">
              <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
              <h1 className="mb-0">
                Empowering Businesses with Smart Sales & Lead Solutions
              </h1>
            </div>

            <p className="mb-4">
              At <strong>My Easy Tax Pro Partners</strong>, we specialize in
              helping businesses grow by connecting them with the right
              customers through powerful sales and lead generation strategies.
              Our mission is simple — to make business expansion easier, faster,
              and more efficient for every brand we partner with.
            </p>

            <p className="mb-4">
              With a blend of data-driven marketing, performance tracking, and
              industry insights, we ensure your business gets high-quality leads
              that convert into long-term success. Whether you’re a startup
              looking for visibility or an established brand aiming to scale,
              our team designs customized strategies that align with your goals.
            </p>

            <p className="mb-4">
              We don’t just deliver leads — we build sustainable growth channels
              that strengthen your sales performance and maximize ROI.
              Partnering with <strong>My Easy Tax Pro Partners</strong> means
              partnering with commitment, expertise, and measurable results.
            </p>

            <div className="row g-0 mb-3">
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>Data-Driven
                  Approach
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>Experienced
                  Team
                </h5>
              </div>
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>24/7 Client
                  Support
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>
                  Result-Oriented Solutions
                </h5>
              </div>
            </div>

            <Link
              to="/contact"
              className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
              data-wow-delay="0.9s"
            >
              Contact Us
            </Link>
          </div>

          {/* Right Column - Image */}
          <div className="col-lg-5" style={{ minHeight: "500px" }}>
            <div className="position-relative h-100">
              <img
                className="position-absolute w-100 h-100 rounded wow zoomIn"
                data-wow-delay="0.9s"
                src="assets/img/mppabout.png"
                alt="About My Easy Tax Pro Partners"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
